import { gql } from "@apollo/client/core";
const GOOGLE_MAPS_API_KEY = gql`
  query {
    googleMapsApiKey
  }
`;
export {
  GOOGLE_MAPS_API_KEY
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ29vZ2xlLW1hcHMuanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaHFsL2dvb2dsZS1tYXBzLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGdxbCB9IGZyb20gJ0BhcG9sbG8vY2xpZW50L2NvcmUnO1xuXG5leHBvcnQgY29uc3QgR09PR0xFX01BUFNfQVBJX0tFWSA9IGdxbGBcbiAgcXVlcnkge1xuICAgIGdvb2dsZU1hcHNBcGlLZXlcbiAgfVxuYDtcbiJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRVksTUFBQyxzQkFBc0I7QUFBQTtBQUFBO0FBQUE7QUFBQTsifQ==
